import bundleFeature from '../../utils/bundleFeature'

import { SpeakersFeatureComponent } from './components'
import reducer from './reducer'
import sagas from './sagas'
import actions from './actions'
import selectors from './selectors'

export default bundleFeature({
  Component: SpeakersFeatureComponent,
  actions,
  reducer,
  sagas,
  selectors,
})
